import { useGetResources } from '@/queries/resources.queries';
import { handleExternalLink } from '@/utils/link-props';
import { Box, Flex, FlexProps, Link, Text } from '@cmpsr/components';

export default function Resources({ ...props }: FlexProps) {
  const route = window.location.pathname;
  const { data: resourcesData } = useGetResources(encodeURIComponent(route));
  const resources = resourcesData ?? [];

  if (!resources || !resources.length) return null;

  return (
    <Flex
      flexDir="column"
      gap={4}
      height="fit-content"
      p={{ base: 5, lg: 12 }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      {...props}
    >
      <Text variant="text-header-M">Additional Resources</Text>
      <Flex flexDirection="column" gap="spacer-4">
        {resources.map((item) => (
          <Box key={item.title}>
            <Link
              key={item.title}
              size="m"
              {...handleExternalLink({ href: item.url })}
              target="_blank"
              display="inline"
              borderBottom="1px solid"
              borderColor="currentColor"
              borderRadius={0}
              fontSize={{ base: '14px', lg: '16px' }}
              fontWeight={{ base: 600, lg: 500 }}
              color="text-link-secondary-default"
            >
              {item.title}
            </Link>
          </Box>
        ))}
      </Flex>
    </Flex>
  );
}
